import { render, staticRenderFns } from "./DocsHome.vue?vue&type=template&id=344866ef"
import script from "./DocsHome.vue?vue&type=script&lang=js"
export * from "./DocsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports